import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertModalDescription } from "@air/primitive-alert-modal";
import Link from "next/link";
import pluralize from "pluralize";
export const DeleteAssetMessageModalDescription = (param)=>{
    let { ignoredAssetIds, removedAssetIds } = param;
    return /*#__PURE__*/ _jsx(AlertModalDescription, {
        className: "pb-2 pt-1",
        children: /*#__PURE__*/ _jsxs("p", {
            className: "text-14",
            children: [
                ignoredAssetIds.length ? "You don't have the necessary permissions to delete ".concat(pluralize("this", ignoredAssetIds.length), " ").concat(pluralize("asset", ignoredAssetIds.length), " in all of ").concat(pluralize("its", ignoredAssetIds.length), " locations.") : "Since you don't have the necessary permissions to delete ".concat(pluralize("this", removedAssetIds.length), " ").concat(pluralize("asset", removedAssetIds.length), " in all of ").concat(pluralize("its", removedAssetIds.length), " locations, ").concat(pluralize("this", removedAssetIds.length), " ").concat(pluralize("asset", removedAssetIds.length), " ").concat(pluralize("was", removedAssetIds.length), " removed from board(s) instead."),
                /*#__PURE__*/ _jsx(Link, {
                    target: "_blank",
                    className: "px-3 text-14 font-bold text-blue-11",
                    href: "https://help.air.inc/en/articles/8584302-deleting-content",
                    children: "Learn more"
                })
            ]
        })
    });
};
